import ReadingGoal from './ReadingGoal';

export default ReadingGoal;
